// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___SbDiE","layoutItem":"styles__layoutItem___ZBo5y","header":"styles__header___jgifb","main":"styles__main___OyHrv"};